import { useQuery } from '@tanstack/react-query';
import { api, apiUrls } from '@/lib/apiClient';
import { toTradeModel } from '@/lib/money';
import type { TradeModelInternal } from '@/types/model.types';

export interface FundTradesParams {
  fundId: string;
  tradeDateAsYyyyMmDd?: string;
  tenant?: string;
}

/**
 * Replaces DataService.fetchFundTrades. `enabled` means the trade list only
 * loads when a fund row is actually expanded, which the Angular version had to
 * arrange by hand.
 */
export function useFundTrades(params: FundTradesParams, enabled = true) {
  return useQuery({
    queryKey: ['trades', params],
    enabled: enabled && Boolean(params.fundId),
    queryFn: async () => {
      const trades = await api.get<TradeModelInternal[]>(apiUrls.trade, {
        operation: `retrieving trades for fund ${params.fundId}`,
        params: {
          fundId: params.fundId,
          tradeDate: params.tradeDateAsYyyyMmDd,
          tenant: params.tenant,
        },
      });
      return trades.map(toTradeModel);
    },
  });
}
